import { render, staticRenderFns } from "./sku_dialog.vue?vue&type=template&id=6fa45136&scoped=true"
import script from "./sku_dialog.vue?vue&type=script&lang=js"
export * from "./sku_dialog.vue?vue&type=script&lang=js"
import style0 from "./sku_dialog.vue?vue&type=style&index=0&id=6fa45136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa45136",
  null
  
)

export default component.exports